<template>
    <div class="main-box mh-a">

        <div class="mobil-new">
            <el-row :gutter="18">
                <el-col :span="8" v-for="(item, index) in newList" :key="`${index}_news`"
                    @click.native="$router.push({ path: `/news-details/${item.id}` })" class="c-pointer">
                    <div class="w360px p-r mh-a news-list border-r ovh hover-shadow">
                        <el-image class="w-total news-img" :src="item.img" fit="cover"></el-image>
                        <div class="news-label c-g-d">
                            <h4 class="pt10 p-a fs16 fw-n ph20 text-indent" style="white-space:pre-line">
                                {{ item.title }}
                            </h4>
                            <p class="text-right pr4 p-a">
                                {{ item.time }}
                            </p>
                        </div>
                        <div class="news-bg p-a w-total c-white pc-hidden"></div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
// import IristarDividing from "@/components/IristarDividing";
// 新闻列表
import newList from "@/assets/news/newsList";
import newListEn from "@/assets/news/newsList-en";
export default {
    name: "IristarNews",
    computed: {
        newList() {
            let newsData =
                this.$store.state.language === "zh" ? newList : newListEn;
            return newsData.slice(0, 3);
        },
    },
    components: {
        // IristarDividing,
    },
};
</script>

<style lang="less">
.el-image__error,
.el-image__inner,
.el-image__placeholder {
    height: auto !important;
}
</style>